export default {
  paged: {
    select: 'id,messageType,to,subject,deliveryProvider,created,responseCode',
    searchSelect: ['to', 'subject'],
    orderBy: 'created desc',
  },
  itemDetail: {
    select:
      'id,messageType,from,replyTo,to,cc,bcc,subject,deliveryProvider,responseCode,errorMessage,created,otherEntity,otherEntityDisplayName,otherEntityId,otherEntityDisplayIdentifier,customArgs,chatMessageId',
    expand: {
      processInstance: { select: 'name' },
      user: { select: 'id,fullName' },
      agent: { select: 'id,name' },
      channel: { select: 'id,name' },
      chatThread: { select: 'id,number,name' },
    },
  },
  eventHistory: {
    select: 'id,mailEvent,updated,smtpId,eventId,messageId,reason,userAgent',
  },
};
